// extracted by mini-css-extract-plugin
export default {"header":"xsellTitle_header","title":"xsellTitle_title","subTitle":"xsellTitle_subTitle","amount":"xsellTitle_amount","benefitPoints":"xsellTitle_benefitPoints"};